export const GENDER_OPTIONS = [
  { key: "Male", val: 'M' },
  { key: "Male Castrated", val: 'MN' },
  { key: "Female", val: 'F' },
  { key: "Female Spayed", val: 'FS' },
];

export const SPECIES_OPTIONS = [
  "Amphibian",
  "Avian",
  "Bovine",
  "Canine",
  "Caprine",
  "Equine",
  "Feline",
  "Lagomorph",
  "Mustelidae",
  "Ovine",
  "Porcine",
  "Other"
];

export const MODALITY_OPTIONS = [
  "CR", "CT", "DX", "EC", "ES", "IO", "MR", "NM", "OT",
  "PT", "RF", "RG", "US", "XA"
].sort();

export const PRIORITIES = [
  {id: '', name: ''},
  {id: 0, name: 'Standard'},
  {id: 1, name: 'STAT', hidden: 1},
  {id: 5, name: 'Priority'},
  {id: 10, name: 'STAT'},
]

export const contrastColor = hex => {
  if (!hex) return '#fff'
  const c = hex.replace('#', '')
  const r = parseInt(c.substr(0, 2), 16)
  const g = parseInt(c.substr(2, 2), 16)
  const b = parseInt(c.substr(4, 2), 16)
  return (r * 299 + g * 587 + b * 114) / 1000 > 128 ? '#000' : '#fff'
}